// ---------------------------------------------------------------------------
// C3: a fatia que o ChartDataSlicer entrega à cena só deve virar uma referência NOVA quando o CONTEÚDO mudou.
//
// A cada tick o app recria todos os objetos de vela (normalização) e o processMathData devolve um array novo;
// por isso igualdade por referência nunca vale. Compara por conteúdo: tamanho e, ponto a ponto, os campos que
// o desenho do filamento e dos candles usam. Os pontos antigos mantêm os mesmos valores no caminho rápido; num
// recálculo completo (vela fechada, carga de histórico) algum valor muda e a fatia é nova.
// O(N) sem alocação (N <= ~2000, só leituras).
// ---------------------------------------------------------------------------

const same = (a: any, b: any) => a === b || (a !== a && b !== b); // NaN == NaN
// As SMAs são somas deslizantes: o 1º tick depois de um recálculo completo as recalcula desde a vela 0 e o resultado
// difere só nos últimos bits (medido: ~1e-12 absoluto, 4e-16 relativo), sem efeito visível. Tolerância de 1e-9 só nelas; o resto é exato.
const near = (a: any, b: any) => a === b || (a !== a && b !== b) || (typeof a === 'number' && typeof b === 'number' && Math.abs(a - b) <= 1e-9 * (Math.abs(a) + Math.abs(b)) + 1e-9);

/** Campos que influenciam o desenho (posição X, Y, Z, cor por alta/baixa e SMAs). */
export function samePoint(a: any, b: any): boolean {
  if (a === b) return true;
  return (
    same(a.timestamp, b.timestamp) && same(a.volume, b.volume) && same(a.close, b.close) && same(a.price, b.price) &&
    same(a.open, b.open) && same(a.high, b.high) && same(a.low, b.low) &&
    same(a.trend, b.trend) && same(a.imf, b.imf) && same(a.momentum, b.momentum) &&
    near(a.sma10, b.sma10) && near(a.sma20, b.sma20) && near(a.sma50, b.sma50) &&
    near(a.sma10Momentum, b.sma10Momentum) && near(a.sma20Momentum, b.sma20Momentum) && near(a.sma50Momentum, b.sma50Momentum) &&
    near(a.sma10Imf, b.sma10Imf) && near(a.sma20Imf, b.sma20Imf) && near(a.sma50Imf, b.sma50Imf)
  );
}

export function sameSliceContent(a: ArrayLike<any> | null | undefined, b: ArrayLike<any> | null | undefined): boolean {
  if (a === b) return true;
  if (!a || !b || a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) if (!samePoint(a[i], b[i])) return false;
  return true;
}
